module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('full-screen', {
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('div', {
    staticClass: "ma3 flex justify-center pl-title"
  }, [(_vm.page === 'course-selection') ? _c('p', {
    staticClass: "b"
  }, [_vm._v("\n        What course is this RoundTable for?\n      ")]) : _vm._e(), _vm._v(" "), (_vm.page === 'online-live') ? _c('p', {
    staticClass: "b"
  }, [_vm._v("What type of RoundTable?")]) : _vm._e(), _vm._v(" "), (_vm.page === 'universe-create-own') ? _c('p', {
    staticClass: "b"
  }, [_vm._v("\n        How would you like to start?\n      ")]) : _vm._e()]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "choose-activity-appear-enter-only"
    }
  }, [(_vm.page === 'course-selection') ? _c('div', {
    key: "course-selection"
  }, _vm._l((_vm.courses_I_teach), function(course, index) {
    return _c('div', {
      key: course.id,
      staticClass: "flex flex-nowrap items-center h3 ph3 course-row center-xs center col-xs-9"
    }, [_c('div', {
      staticClass: "grow flex flex-nowrap items-center h3 ph3 clickable flex-grow course-item-content start-xs",
      on: {
        "click": function($event) {
          return _vm.handleSelectCourse(course.id)
        }
      }
    }, [_c('div', {
      staticClass: "flex-grow pl-subheading"
    }, [_vm._v("\n              " + _vm._s(course.title) + "\n              " + _vm._s(course.sections[0] ? ' - ' + course.sections[0] : '') + "\n            ")])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.page === 'online-live') ? _c('section', {
    key: "live-online",
    staticClass: "choose-universe-live-online h-auto flex flex-wrap"
  }, [_c('div', {
    staticClass: "flex-grow tc"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": _vm.selectOnline
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px"
    },
    attrs: {
      "src": "/static/online_roundtable_icons/online.svg",
      "alt": "written roundtable"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("Written")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n              A tool for written blended discussions and collaboration.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pill pl-caption"
  }, [_vm._v("Create Written RoundTable")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow tc"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": _vm.createLive
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px"
    },
    attrs: {
      "src": "/static/live_discussion/live.svg",
      "alt": "verbal discussion"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("Verbal")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n              A tool for facilitating and tracking face-to-face discussions.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pill pl-caption"
  }, [_vm._v("Create Verbal RoundTable")])])]), _vm._v(" "), (!_vm.getProfile.is_paid) ? _c('div', {
    staticClass: "center pl-title w-80 pa3",
    staticStyle: {
      "background-color": "#edf1f7"
    }
  }, [_vm._v("\n          You have\n          "), _c('span', {
    staticClass: "ruby"
  }, [_vm._v(_vm._s(_vm.getProfile.activity_passes) + " roundtables")]), _vm._v("\n          in your free trial. "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "clickable b",
    on: {
      "click": _vm.openUpgradeOverlay
    }
  }, [_vm._v("Click here")]), _vm._v("\n          to upgrade.\n        ")]) : _vm._e()]) : (_vm.page === 'universe-create-own') ? _c('section', {
    key: "universe-create-own",
    staticClass: "choose-universe-create-own h-auto flex center-xs flex-wrap"
  }, [_c('div', {
    staticClass: "flex-grow tc"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": _vm.goToUniverse
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px"
    },
    attrs: {
      "src": "/static/science.svg",
      "alt": "parlay universe"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("Parlay Universe")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n              Browse Parlay's library of discussion topics.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pill pl-caption"
  }, [_vm._v("Browse Universe")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow tc"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": _vm.goToMyPortfolio
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px",
      "width": "95px",
      "border-radius": "50%",
      "align-self": "center"
    },
    attrs: {
      "src": _vm.getProfile.avatar_url,
      "alt": "easel"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("My Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n              Your personal portfolio of discussion topics.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pill pl-caption"
  }, [_vm._v("Browse Portfolio")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow tc"
  }, [_c('div', {
    staticClass: "ma3 grow justify-center choose-activity-btn clickable",
    on: {
      "click": _vm.createOnline
    }
  }, [_c('img', {
    staticStyle: {
      "height": "95px"
    },
    attrs: {
      "src": "/static/easel.svg",
      "alt": "easel"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "b mt3 f4"
  }, [_vm._v("Create My Own")]), _vm._v(" "), _c('div', {
    staticClass: "pl-caption pv2 mv2"
  }, [_vm._v("\n              Start from scratch or use an instructional template.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pill pl-caption"
  }, [_vm._v("Start from Scratch")])])]), _vm._v(" "), _c('pl-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page === 'universe-create-own'),
      expression: "page === 'universe-create-own'"
    }],
    key: "back",
    staticClass: "pl-ruby-font pl-border",
    nativeOn: {
      "click": function($event) {
        _vm.page = 'online-live'
      }
    }
  }, [_vm._v("Back\n        ")])], 1) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-78778da6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/fullScreenChooseActivity.vue
// module id = 913
// module chunks = 61